import { Action } from '@ngrx/store'
import * as ImageTypesTypes from './image-types.types'
import { ImageType } from './image-types.interface'

// Fetch ImageType Types
export class FetchImageTypesRequest implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchImageTypesSuccess implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPES_SUCCESS
  constructor(
    public payload: ImageType[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchImageTypesFailure implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPES_FAILURE
  constructor(public payload: any) {}
}

// Fetch ImageType Type
export class FetchImageTypeRequest implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPE_REQUEST
  constructor(public id: number) {}
}

export class FetchImageTypeSuccess implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPE_SUCCESS
  constructor(public payload: ImageType) {}
}

export class FetchImageTypeFailure implements Action {
  readonly type = ImageTypesTypes.FETCH_IMAGE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Delete ImageType Type
export class DeleteImageTypeRequest implements Action {
  readonly type = ImageTypesTypes.DELETE_IMAGE_TYPE_REQUEST
  constructor(public id: number) {}
}

export class DeleteImageTypeSuccess implements Action {
  readonly type = ImageTypesTypes.DELETE_IMAGE_TYPE_SUCCESS
  constructor() {}
}

export class DeleteImageTypeFailure implements Action {
  readonly type = ImageTypesTypes.DELETE_IMAGE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Create ImageType Type
export class CreateImageTypeRequest implements Action {
  readonly type = ImageTypesTypes.CREATE_IMAGE_TYPE_REQUEST
  constructor(public payload) {}
}

export class CreateImageTypeSuccess implements Action {
  readonly type = ImageTypesTypes.CREATE_IMAGE_TYPE_SUCCESS
  constructor() {}
}

export class CreateImageTypeFailure implements Action {
  readonly type = ImageTypesTypes.CREATE_IMAGE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Update ImageType Type
export class UpdateImageTypeRequest implements Action {
  readonly type = ImageTypesTypes.UPDATE_IMAGE_TYPE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateImageTypeSuccess implements Action {
  readonly type = ImageTypesTypes.UPDATE_IMAGE_TYPE_SUCCESS
  constructor() {}
}

export class UpdateImageTypeFailure implements Action {
  readonly type = ImageTypesTypes.UPDATE_IMAGE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = ImageTypesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = ImageTypesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateImageTypeRequest
  | UpdateImageTypeSuccess
  | UpdateImageTypeFailure
  | FetchImageTypesSuccess
  | FetchImageTypesFailure
  | FetchImageTypesRequest
  | FetchImageTypeSuccess
  | FetchImageTypeFailure
  | FetchImageTypeRequest
  | CreateImageTypeRequest
  | CreateImageTypeSuccess
  | CreateImageTypeFailure
  | DeleteImageTypeRequest
  | DeleteImageTypeSuccess
  | DeleteImageTypeFailure
  | SetDefaultData
  | UpdateField
  | FetchImageTypesRequest
  | FetchImageTypesSuccess
  | FetchImageTypesFailure
